import moment from 'moment';

import { SessionPolicy } from '../../../../types/hubInterfaces';
import { SchoolHolidayTerm } from '../../../../types/hubTypes';
import { isPauseAllowedForHoliday } from '../helpers';
import { isSummerPausePromoEnabled } from '../helpers';

const useCanPauseEarly = (enrolmentPolicy: SessionPolicy, holiday?: SchoolHolidayTerm) => {
  const holidayIsSummer = holiday?.type === 'Summer Holiday';
  const allowedForHoliday = holidayIsSummer && isPauseAllowedForHoliday(enrolmentPolicy, holiday);

  const startOfHoliday = holiday?.startDate;
  const endOfHoliday = holiday?.endDate;
  const startDate = moment(startOfHoliday);

  const endDate = moment(endOfHoliday).utc().format();

  if (!startOfHoliday || !endOfHoliday || !moment(startDate).isValid() || !moment(endOfHoliday).isValid()) {
    return { error: new Error('Invalid start date or end date.'), startDate, endDate, canPauseEarly: false };
  }

  return {
    error: null,
    startDate,
    endDate,
    canPauseEarly: allowedForHoliday && isSummerPausePromoEnabled(),
  };
};

export default useCanPauseEarly;
